<template>
  <v-skeleton-loader width="100%" max-width="555" v-if="this.partnerFilesLoading" type="card">
  </v-skeleton-loader>
    <div v-else>
      <div class="mt-2" v-for="attachment in partnerFiles" :key="attachment.upload_id">
        <FileListComponent :attachment="attachment" />
      </div>
      <Pagination
          class="mt-9 mb-9"
          :page="filters.page"
          :pageCount="+this.partnerFilesPageCount"
          v-on:pageChange="onPageChange"/>
    </div>
</template>
<script>

import Block from '@/mixins/Block.js'
import { mapGetters, mapActions } from 'vuex'
import Pagination from '@/components/Pagination.vue'
import FileListComponent from '@/components/FileListComponent.vue'
import Filter from "@/mixins/Filter";

export default {
	components: {
		Pagination,
    FileListComponent
	},
	mixins: [Block,Filter],
	data() {
		return {
			attrs: {
				elevation: 0,
				class: 'pt-7',
			},
		}
	},
	methods: {
		...mapActions('event', ['getPartnerFiles']),
		...mapActions('app', ['setPageTitle']),
	},
	mounted() {
		this.setPageTitle('Attachments')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	computed: {
		...mapGetters('event', ['partnerFiles','partnerFilesLoading','partnerFilesError','partnerFilesPageCount']),
	},
	created() {
    if(this.$route.query.partner_id !== undefined){
      this.getPartnerFiles(this.requestQuery)
    }

	},
}
</script>
<style lang="scss"></style>
